module.exports = __webpack_public_path__ + "static/media/barcode_search.612781c9.svg";